import { useNavigate } from 'react-router-dom';
import { Button } from '../components/primitives/index.js';
import { AppHeader } from '../components/layout/AppHeader.js';

export function NotFoundScreen() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-full flex-col">
      <AppHeader />
      <main className="mx-auto flex w-full max-w-[560px] flex-1 flex-col justify-center gap-4 px-4 py-16 sm:px-8">
        <h1 className="text-[34px] font-bold leading-tight tracking-[-0.02em]">
          No page at this address.
        </h1>
        <p className="text-[17px] leading-relaxed text-ink-muted">
          A closed room leaves its link behind. Room codes go on the home screen.
        </p>
        <div className="pt-2">
          <Button variant="primary" size="lg" onClick={() => navigate('/')}>
            Go to the home screen
          </Button>
        </div>
      </main>
    </div>
  );
}
